import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const IPSettingsView = React.lazy(() => import("./IPSettings.view"));

const IPSettingsLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <IPSettingsView />
  </React.Suspense>
);
export default () => <IPSettingsLoadable />;
